<template>
    <div class="">
        <BanPart text="Submission"/>
        <PageContent/>
    </div>
</template>

<script>
import BanPart from '@/components/BanPart/BanPart.vue'
import PageContent from './PageContent/PageContent.vue'
    export default {
        components:{
            BanPart,
            PageContent
        }
    }
</script>

<style lang="less" scoped>
</style>